import { template as template_6c95c9d0f6454ff1af828dabc7ede57e } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../routes/render';
const Render = template_6c95c9d0f6454ff1af828dabc7ede57e(`
  <div
    data-prerender
    data-prerender-id={{@model.cardId}}
    data-prerender-nonce={{@model.nonce}}
    data-prerender-status={{@model.status}}
  >
    {{outlet}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    model: Model;
}>;
export default RouteTemplate(Render);
